import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersBelongingEmployeesMeetingNotesIndexRequestType,
  ApiManagersBelongingEmployeesMeetingNotesIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersBelongingEmployeesMeetingNotesIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersBelongingEmployeesMeetingNotesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersBelongingEmployeesMeetingNotesIndexResponseType>(
      "/api/managers/belonging_employees/meeting_notes",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersBelongingEmployeesMeetingNotesIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersBelongingEmployeesMeetingNotesIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersBelongingEmployeesMeetingNotesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersBelongingEmployeesMeetingNotesIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
